import { CircularProgress, Box, Typography } from '@mui/material';
import { useState } from 'react';
import { Device, DeviceLastReading } from 'types';
import styles from './TankLevelIndicator.module.scss';
import { green, lime, orange, red, yellow } from '@mui/material/colors';

interface TankLevelIndicatorProps {
    tankLevelPercentage?: DeviceLastReading['tank'] | null;
    gallons?: Device['gallons'];
}

export function TankLevelIndicator({
    tankLevelPercentage,
    gallons,
}: TankLevelIndicatorProps) {
    const [isHovered, setIsHovered] = useState(false);

    const tankValue =
        tankLevelPercentage && tankLevelPercentage > 100
            ? 100
            : tankLevelPercentage ?? 0;

    let color: string = green[500];

    switch (true) {
        case tankValue >= 80:
            color = green[500];
            break;
        case tankValue < 80 && tankValue >= 60:
            color = lime[500];
            break;
        case tankValue < 60 && tankValue >= 40:
            color = yellow[500];
            break;
        case tankValue < 40 && tankValue >= 20:
            color = orange[500];
            break;
        default:
            color = red[500];
            break;
    }

    const tankLevelText =
        !tankLevelPercentage && tankLevelPercentage !== 0
            ? 'N/A'
            : gallons && isHovered
            ? `${Math.round(gallons)}`
            : `${Math.round(tankValue)}%`;

    return (
        <Box className={styles.indicatorContainer}>
            <CircularProgress
                variant="determinate"
                value={tankValue ?? 0}
                data-testid={color + '-tank-indicator'}
                size="3rem"
                sx={{ color }}
            />
            <Box
                className={styles.percentageContainer}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <Typography
                    variant="caption"
                    component="span"
                    color="text.secondary"
                >
                    {tankLevelText}
                </Typography>
                {isHovered && gallons && (
                    <Typography
                        variant="caption"
                        component="span"
                        color="text.secondary"
                    >
                        gal
                    </Typography>
                )}
            </Box>
        </Box>
    );
}
